import moment from "moment";

export const dateSortComparator = (v1, v2) => {
  const t1 = v1 ? new Date(v1).getTime() : 0;
  const t2 = v2 ? new Date(v2).getTime() : 0;
  return (Number.isNaN(t1) ? 0 : t1) - (Number.isNaN(t2) ? 0 : t2);
};

/** Display format: Jan 24, 2026 */
export const formatEntityDate = (value) =>
  value ? moment(value).format("MMM D, YYYY") : "-";


export const getEntityDateColumn = ({
  field = "date",
  headerName = "Creation Date",
  flex,
  minWidth,
  width,
} = {}) => {
  const useFixedWidth = width != null;
  return {
    field,
    headerName,
    ...(useFixedWidth
      ? { width, ...(flex != null ? { flex } : {}), ...(minWidth != null ? { minWidth } : {}) }
      : {
          flex: flex ?? 1,
          minWidth: minWidth ?? 140,
        }),
    sortComparator: dateSortComparator,
    valueFormatter: (value) => formatEntityDate(value),
    renderCell: (params) =>
      formatEntityDate(params.row?.[field] ?? params.value),
  };
};
